import { ApiFactory } from '../factories/api.factory';

export class UsersApi extends ApiFactory { }
